import React, {useEffect} from "react";
import {useAuth} from "../components/auth.context";
import {Navigate} from "react-router-dom";

const Logout:React.FC<{}> = () => {
    const auth = useAuth();
    useEffect(()=>{
        if(auth.keycloak.authenticated) {
            auth.keycloak.logout().then();
        }
    },[])

    if(!auth.keycloak.authenticated) {
        return <Navigate to={"/"}/>
    }
    return null;
}

export default Logout;